<template>
  <div class="costContainer">
    <div>
      <div class="costContent">
        <van-cell-group>
          <van-field v-model="carInfo.carBrand" label="车辆信息" input-align="right" readonly />
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="carInfo.driverName" label="驾驶员" readonly input-align="right" />
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="carInfo.driverPhone" label="司机电话" readonly input-align="right" />
        </van-cell-group>

        <van-cell-group>
          <van-field v-model="carInfo.departTime" label="发车时间" input-align="right" @click="showStartTime" />
          <van-popup v-model="showStartDate" position="bottom">
            <van-datetime-picker v-model="departTime" type="datetime" title="选择年月日" :min-date="minDate"
              @confirm="comfirmStartTime" @cancel="showStartDate = false" />
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="carInfo.comebackTime" label="回场时间" input-align="right" @click="showComeBackTime" />
          <van-popup v-model="showComeBackDate" position="bottom">
            <van-datetime-picker v-model="comebackTime" type="datetime" title="选择年月日" :min-date="minDate"
               @confirm="comfirmComeBackTime" @cancel="showComeBackDate = false" />
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="carInfo.useDuration" label="用车时长" type="number" input-align="right" />
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="carInfo.startMileage" label="起始里程数" type="number" input-align="right"
            @input="startMileage" />
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="carInfo.endMileage" label="终止里程数" input-align="right" @input="endMileage" />
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="carInfo.realityMileage" label="实际行驶里程数" readonly input-align="right" />
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="carInfo.travelCost" label="行驶费用" type="number" readonly input-align="right"
            @input="travelCost" />
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="carInfo.roadBridgeCost" label="路桥费" type="number" input-align="right"
            @input="roadBridgeCost" />
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="carInfo.otherCost" type="number" label="其他费用" input-align="right" @input="otherCost" />
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="carInfo.totalCost" label="用车费用结算" input-align="right" readonly />
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="carInfo.remarks" rows="5" autosize label="备注" type="textarea" input-align="right" />
        </van-cell-group>
      </div>
      <div class="footerBtn">
        <div>
          <van-button @click="returnMyApply" type="default" size="small" style="width: 30%">取消</van-button>
          <van-button :disabled="btnloading" type="info" size="small" @click="confirm"
            style="width: 70%; background-color: #4ea27c">确认</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/car.js";
import moment from "moment";
export default {
  name: "carCostDetail",
  data() {
    return {
      carInfo: {
        carBrand: "",
        driverName: "",
        driverPhone:'',
        departTime: "",
        comebackTime: "",
        useDuration: "",
        startMileage: "",
        endMileage: "",
        realityMileage: "",
        travelCost: "",
        roadBridgeCost: "",
        otherCost: "",
        totalCost: "",
        remarks: ""
      },
      minDate: new Date(2018, 10, 1),
      departTime: null,
      comebackTime: null,
      showStartDate: false,
      showComeBackDate: false,
      btnloading: false
    };
  },
  mounted() {
    this.btnloading = false;
    sessionStorage.removeItem("carInfo");
    let applyNumber = this.$route.query.applyNumber;
    if (this.$route.query.applyNumber) {
      this.postqueryCostDetails(applyNumber);
    }

  },
  methods: {
    //返回用车申请
    returnMyApply() {
      this.$router.go(-1);
      // this.$router.replace({
      //   path: "/car/facility/useCarApply",
      //   query: { name: 3 }
      // });
    },
    //显示发车时间
    showStartTime() {
      this.showStartDate = true;
    },
    // 确定 发车时间
    comfirmStartTime(value) {
      this.carInfo.departTime = moment(value).format("YYYY-MM-DD HH:mm");
      this.showStartDate = false;
    },
    //显示回场时间
    showComeBackTime() {
      this.showComeBackDate = true;
    },
    // 确定 回场时间
    comfirmComeBackTime(value) {
      this.carInfo.comebackTime = moment(value).format("YYYY-MM-DD HH:mm");
      this.showComeBackDate = false;
    },

    computeCost(value, name) {
      if (
        name === "travelCost" ||
        name === "roadBridgeCost" ||
        name === "otherCost"
      ) {
        if (String(value).includes(".")) {
          let numDian = value.toString().split(".")[1].length;
          if (numDian > 2) {
            let dotIndex = value.indexOf(".");
            this.carInfo[name] = value.substring(0, dotIndex + 3);
            return this.$toast("金额精确到两位数");
          }
        }
      }
      if (name === "startMileage" || name === "endMileage") {
        if (String(value).includes(".")) {
          let numDian = value.toString().split(".")[1].length;
          if (numDian > 2) {
            let dotIndex = value.indexOf(".");
            this.carInfo[name] = value.substring(0, dotIndex + 3);
            return this.$toast("公里数精确到两位数");
          }
        }
      }
    },
    // 计算费用
    calculateCost(value, name) {
      this.computeCost(value, name);

      if (
        name === "travelCost" ||
        name === "roadBridgeCost" ||
        name === "otherCost"
      ) {
        let totalCost = 0;
        for (let n of ["travelCost", "roadBridgeCost", "otherCost"]) {
          totalCost += Number(this.carInfo[n]) * 100;
        }
        this.carInfo.totalCost = totalCost / 100;
      }
      if (name === "startMileage" || name === "endMileage") {
        let mileage = 0;
        // for (let n of ["startMileage", "endMileage"]) {

        //   mileage += Number(this.carInfo[n]) * 100;
        // }
        mileage =
          Number(this.carInfo.endMileage) * 100 -
          Number(this.carInfo.startMileage) * 100;
        console.log('mileage', mileage);
        this.carInfo.realityMileage = (mileage / 100).toFixed(2);
      }
    },
    // 开始公里数
    startMileage(value) {
      this.calculateCost(value, "startMileage");
    },
    // 结束公里数
    endMileage(value) {
      this.calculateCost(value, "endMileage");
    },
    // 行驶费用
    travelCost(value) {
      this.calculateCost(value, "travelCost");
    },
    // 路桥费费用
    roadBridgeCost(value) {
      this.calculateCost(value, "roadBridgeCost");
    },
    // 其他费用
    otherCost(value) {
      this.calculateCost(value, "otherCost");
    },
    //查看费用详情
    postqueryCostDetails(applyNumber) {
      apis
        .queryCostDetails({ applyNumber: applyNumber })
        .then(res => {
          this.carInfo = res.data;
          this.carInfo.departTime = moment(res.data.departTime).format(
            "YYYY-MM-DD HH:mm"
          );
          this.carInfo.comebackTime = moment(res.data.comebackTime).format(
            "YYYY-MM-DD HH:mm"
          );
          this.departTime = new Date(res.data.departTime);
          this.comebackTime = new Date(res.data.comebackTime);
          console.log('this.carInfo', this.carInfo);
        });
    },
    // 修改费用详情
    confirm() {
      this.btnloading = true;
      const time1 = new Date(this.departTime).getTime();
      const time2 = new Date(this.comebackTime).getTime();
      if (time1 > time2) {
        return this.$toast("发车时间不能大于等于回场时间");
      }
      if (Number(this.carInfo.startMileage) > Number(this.carInfo.endMileage)) {
        return this.$toast("开始里程数不能大于结束里程数");
      }
      const json = {
        applyNumber: this.$route.query.applyNumber,
        ...this.carInfo,
        departTime: new Date(this.departTime),
        comebackTime: new Date(this.comebackTime)
      };
      apis.insertCarCost(json).then(res => {
        if (res.code === 200) {
          this.$router.go(-1);
          // this.$router.replace({
          //   path: "/car/facility/useCarApply",
          //   query: { name: 3 }
          // });
          this.btnloading = false;
        } else {
          this.btnloading = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .costContainer {
    width: 100%;
  }

  .footerBtn {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .costContainer {
    width: 276px * $zoom;
  }

  .footerBtn {
    width: 276px * $zoom;
  }
}

.costContainer {
  margin: auto;
  background-color: #f3f3f5;

  // display: flex;
  // flex-direction: column;
  .costContent {
    height: calc(100vh - 90px);
    overflow-y: auto;
    padding-bottom: 20px;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .footerBtn {
    // width: 680px;
    position: fixed;
    bottom: 0;
    background-color: #f7f9fa;

    ::v-deep(.van-button--small) {
      height: 88px;
      border-radius: 0;
      font-size: 27px;
      border: 0;
    }
  }
}
</style>
